<template>
  <div id="page-forms">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <template>
            <v-card flat>
              <v-card-text>
                <v-toolbar color="white" dark flat dense cad>
                  <v-toolbar-title class="indigo--text"
                    >Datos de contrato</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <template>
                  <v-form ref="form">
                    <v-layout>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="rut"
                          :error-messages="rutErrors"
                          maxlength="15"
                          label="Rut"
                          :box="isDisabled || disableonmodifica"
                          :readonly="isDisabled || disableonmodifica"
                          @focusout="loadProveedor"
                          @input="$v.rut.$touch()"
                          @blur="
                            tipeView == 'modifica' ? $v.rut.$touch() : null
                          "
                        ></v-text-field>
                        <v-text-field
                          v-model="codigoValue"
                          maxlength="10"
                          :error-messages="codigoErrors"
                          label="Codigo"
                          :box="isDisabled || disableonmodifica"
                          :readonly="isDisabled || disableonmodifica"
                          @input="$v.codigoValue.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.codigoValue.$touch()
                              : null
                          "
                        ></v-text-field>
                        <v-text-field
                          v-model="periodoValue"
                          maxlength="4"
                          :error-messages="periodoErrors"
                          label="Período"
                          :box="isDisabled || disableonmodifica"
                          :readonly="isDisabled || disableonmodifica"
                          @input="$v.periodoValue.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.periodoValue.$touch()
                              : null
                          "
                        ></v-text-field>
                        <v-text-field
                          v-model="itemContratoValue"
                          :error-messages="itemErrors"
                          maxlength="50"
                          label="Item"
                          :box="isDisabled || disableonmodifica"
                          :readonly="isDisabled || disableonmodifica"
                          @input="$v.itemContratoValue.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.itemContratoValue.$touch()
                              : null
                          "
                        ></v-text-field>
                        <v-select
                          v-model="proceso"
                          :items="procesoSelect"
                          item-text="text"
                          item-value="value"
                          :error-messages="procesoErrors"
                          label="Proceso"
                          :box="isDisabled || disableonmodifica"
                          :readonly="isDisabled || disableonmodifica"
                          @input="$v.proceso.$touch()"
                          @blur="
                            tipeView == 'modifica' ? $v.proceso.$touch() : null
                          "
                        ></v-select>
                        <v-textarea
                          name="input-7-1"
                          v-model="descripcion"
                          label="Descripción"
                          value
                          maxlength="250"
                          counter="250"
                          :disabled="tipeView == 'consulta'"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 md1></v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="razonSocial"
                          :error-messages="razonSocialErrors"
                          label="Razon Social"
                          :box="isDisabled || habilita"
                          :readonly="isDisabled || habilita"
                          @input="$v.razonSocial.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.razonSocial.$touch()
                              : null
                          "
                        ></v-text-field>
                        <v-select
                          v-model="regionValue"
                          item-text="nombre"
                          item-value="code"
                          :items="regionesSelect"
                          :error-messages="regionErrors"
                          label="Region"
                          :box="isDisabled || habilita"
                          :readonly="isDisabled || habilita"
                          @change="comunaFiltro()"
                          @input="$v.regionValue.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.regionValue.$touch()
                              : null
                          "
                        ></v-select>
                        <v-select
                          v-model="comunaValue"
                          :items="comunasSelect"
                          item-text="nombre"
                          item-value="code"
                          :error-messages="comunaErrors"
                          label="Comuna"
                          :box="isDisabled || habilita"
                          :readonly="isDisabled || habilita"
                          @input="$v.comunaValue.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.comunaValue.$touch()
                              : null
                          "
                        ></v-select>
                        <v-text-field
                          v-model="direccion"
                          label="Direccion"
                          :box="isDisabled"
                          :readonly="isDisabled"
                          @input="$v.direccion.$touch()"
                          @blur="
                            tipeView == 'modifica'
                              ? $v.direccion.$touch()
                              : null
                          "
                        ></v-text-field>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Fecha inicio contrato"
                              prepend-icon="event"
                              v-on="on"
                              :disabled="tipeView === 'consulta'"
                              v-bind="attrs"
                              v-model="fechaInicioFormatted"
                              @blur="
                                fechaInicio = parseDate(fechaInicioFormatted)
                              "
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fechaInicio"
                            @input="menu1 = false"
                            no-title
                            locale="es"
                            first-day-of-week="1"
                            :disabled="tipeView === 'consulta'"
                          ></v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Fecha fin contrato"
                              prepend-icon="event"
                              v-on="on"
                              :disabled="tipeView === 'consulta'"
                              v-bind="attrs"
                              v-model="fechaFinFormatted"
                              @blur="fechaFin = parseDate(fechaFinFormatted)"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fechaFin"
                            @input="menu2 = false"
                            no-title
                            locale="es"
                            first-day-of-week="1"
                            :disabled="tipeView === 'consulta'"
                          ></v-date-picker>
                        </v-menu>

                        <v-flex xs12 sm6></v-flex>
                      </v-flex>
                    </v-layout>
                    <template>
                      <v-card-actions class="pb-3">
                        <!-- se modifico !valid -->
                        <v-btn
                          :loading="loading"
                          v-if="tipeView == 'modifica'"
                          :disabled="false"
                          color="primary"
                          class="mb-2"
                          @click="editContrato()"
                        >
                          Guardar
                          <v-icon right dark>save</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </template>
                  </v-form>
                </template>
                <v-spacer></v-spacer>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-card>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import FilaContrato from "@/modules/configuration/contrato/FilaContrato.vue";

export default {
  name: "proveedor-data",
  components: {
    FilaContrato,
  },
  mixins: [misMixins, validationMixin],
  props: {
    //tipeView: ""
  },
  data: (vm) => {
    return {
      allowSpaces: false,
      periodoValue: "",
      itemContratoValue: "",
      codigoValue: "",
      razonSocial: "",
      rut: "",
      direccion: "",
      regionValue: "",
      comunaValue: "",
      regionesSelect: [],
      comunasSelect: [],
      proceso: "",
      procesoSelect: [
        "IMPRESIÓN",
        "APLICACION",
        "CAPACITACION",
        "CAPTURA",
        "PREGUNTAS",
        "VALIDACIÓN",
      ],
      descripcion: "",
      itemContratoSelect: [],
      contrato: "",
      contratoId: "",
      id: "",
      loading: false,
      tipeView: "",

      menu1: false,
      menu2: false,
      fechaInicio: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      fechaInicioFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10)
      ),
      fechaFin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      fechaFinFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10)
      ),
    };
  },

  validations: {
    rut: { required, maxLength: maxLength(10) },
    regionValue: { required },
    razonSocial: { required },
    direccion: { required },
    comunaValue: { required },
    codigoValue: { required },
    itemContratoValue: { required },
    periodoValue: { required },
    proceso: { required },
    fechaInicio: { required },
  },
  computed: {
    regionErrors() {
      const errors = [];
      if (!this.$v.regionValue.$dirty) return errors;
      !this.$v.regionValue.required && errors.push("La región es obligatoria.");
      return errors;
    },
    comunaErrors() {
      const errors = [];
      if (!this.$v.comunaValue.$dirty) return errors;
      !this.$v.comunaValue.required && errors.push("La comuna es obligatoria.");
      return errors;
    },
    razonSocialErrors() {
      const errors = [];
      if (!this.$v.razonSocial.$dirty) return errors;
      !this.$v.razonSocial.required &&
        errors.push("La razón social es obligatoria.");
      return errors;
    },
    procesoErrors() {
      const errors = [];
      if (!this.$v.proceso.$dirty) return errors;
      !this.$v.proceso.required && errors.push("El proceso es obligatorio.");
      return errors;
    },
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      this.$v.rut.$model.length > 15 &&
        errors.push("El RUT debe tener como máximo 15 caracteres.");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigoValue.$dirty) return errors;
      !this.$v.codigoValue.required && errors.push("Código es obligatorio.");
      this.$v.codigoValue.$model.length > 10 &&
        errors.push("El código debe tener como máximo 10 caracteres.");
      return errors;
    },
    itemErrors() {
      const errors = [];
      if (!this.$v.itemContratoValue.$dirty) return errors;
      !this.$v.itemContratoValue.required &&
        errors.push("El ítem es obligatorio.");
      this.$v.itemContratoValue.$model.length > 10 &&
        errors.push("El ítem debe tener como máximo 50 caracteres.");
      return errors;
    },
    periodoErrors() {
      const errors = [];
      if (!this.$v.periodoValue.$dirty) return errors;
      if (!this.$v.periodoValue.required) {
        errors.push("Periodo es obligatorio.");
      } else if (!/^\d+$/.test(this.$v.periodoValue.$model)) {
        errors.push("El período debe ser numérico2.");
      } else if (this.$v.periodoValue.$model.length > 4) {
        errors.push("El período debe tener como máximo 4 caracteres.");
      }

      return errors;
    },
    isDisabled() {
      if (this.tipeView && this.tipeView == "consulta") {
        return true;
      }
    },
    disableonmodifica() {
      if (this.tipeView && this.tipeView == "modifica") {
        return true;
      }
    },
    habilita() {
      if (this.tipeView && this.tipeView == "modifica") {
        return false;
      }
    },
  },
  watch: {
    fechaFin(newVal) {
      this.fechaFinFormatted = this.formatDate(this.fechaFin);
      console.log("fechaFinFormatted::" + this.fechaFinFormatted);
      console.log("fechaFin::" + this.fechaFin);
      console.log("fechaInicio::" + newVal);
      this.$emit('fecha-fin-actualizada', newVal); // Emitir la fecha
    },
    fechaInicio(val) {
      this.fechaInicioFormatted = this.formatDate(this.fechaInicio);
    },
  },
  mounted() {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    // this.contratoId = this.$route.params.contratoId;
    this.tipeView = this.$route.params.tipeView;
    // console.log("st::detalle:" + JSON.stringify(this.$route.params, null, 2));
    // console.log("created:" + this.tipeView + "::" + this.contratoId);
    if (this.tipeView == "consulta") {
      this.loadData();
    }
    if (this.tipeView == "modifica") {
      this.loadDataComuna();
      this.loadData();
    }

    if (this.tipeView == null || this.tipeView == "") {
      this.loadData();
      this.tipeView = "consulta";
      this.disableonmodifica();
      this.isDisabled();
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToISO(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    editContrato() {
      this.loading = true;
      /// se debe validar el tipeo de los datos
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let razonSoc = this.razonSocial;
      let dir = this.direccion;
      let idComuna = this.comunaValue.code;
      if (
        this.comunaValue.code == null ||
        this.comunaValue.code === "undefined"
      ) {
        idComuna = this.comunaValue;
      }
      this.body = {
        razonSocial: razonSoc,
        direccion: dir,
        idComuna: idComuna,
        idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        descripcion: this.descripcion,
        fechaInicio:
          this.fechaInicio && this.fechaInicio != null
            ? this.formatoFecha(this.fechaInicio)
            : null,
        fechaFin:
          this.fechaFin && this.fechaFin != null
            ? this.formatoFecha(this.fechaFin)
            : null,
      };

      axios
        .put("/proveedor/" + this.id, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_UPDATE");
          this.$router.replace({ name: "ProveedorImpresion" }).catch(() => {
            //console.log("catch editrovider");
          });
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },
    async loadContratoData() {
      return await axios
        .get("/contrato/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadProveedor() {
      if (this.rut == "") return [];
      //console.log("loadProveedor:" + this.rut);
      return await axios
        .get("/proveedor/rut/" + this.rut)
        .then((response) => {
          if (!response.data.code || response.data.code === "undefined") {
            this.prov = response.data;
            this.razonSocial = this.prov.razonSocial;
            this.direccion = this.prov.direccion;
            this.regionValue = this.prov.idComuna.idRegion.id;
            this.comunaValue = this.prov.idComuna.id;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadData() {
      this.contrato = await this.loadContratoData();
      this.rut = this.contrato.proveedor.rut;
      this.id = this.contrato.proveedor.id;
      this.razonSocial = this.contrato.proveedor.razonSocial;
      this.direccion = this.contrato.proveedor.direccion;
      this.regionValue = {
        nombre: this.contrato.proveedor.idComuna.idRegion.nombre,
        code: this.contrato.proveedor.idComuna.idRegion.id,
      };
      this.regionesSelect = [
        {
          nombre: this.contrato.proveedor.idComuna.idRegion.nombre,
          code: this.contrato.proveedor.idComuna.idRegion.id,
        },
      ];
      this.comunaValue = {
        nombre: this.contrato.proveedor.idComuna.nombre,
        code: this.contrato.proveedor.idComuna.id,
      };
      this.comunasSelect = [
        {
          nombre: this.contrato.proveedor.idComuna.nombre,
          code: this.contrato.proveedor.idComuna.id,
        },
      ];
      this.direccion = this.contrato.proveedor.direccion;
      this.codigoValue = this.contrato.codigo;
      this.itemContratoValue = this.contrato.itemContrato;
      this.periodoValue = this.contrato.periodo;
      // this.periodoSelect = [this.contrato.periodo];
      this.descripcion = this.contrato.descripcion;
      this.proceso = this.contrato.proceso;
      this.fechaInicio = this.formatDateToISO(this.contrato.fechaInicio);
      this.fechaFin = this.formatDateToISO(this.contrato.fechaFin);
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProveedorImpresion",
        });
      }, 1000);
    },
  },
};
</script>
